// extracted by mini-css-extract-plugin
export default {"button":"LostAndFound_button__8e4tl"};